import * as THREE from 'three';
import type { WorldState } from '../world/state/types';
import { forEachMarkedMesh } from './markup';
import { MATERIAL_UNIFORMS, patchMaterial } from './materials';

/** Snow on `snow`-marked meshes; the shader code lives in src/render/materials/ (single patch point). */
export class SurfaceEffects {
  readonly uniforms = MATERIAL_UNIFORMS;
  private count = 0;

  /** Patches every mesh marked `snow: true` under root. */
  apply(root: THREE.Object3D): void {
    forEachMarkedMesh(root, 'snow', (mesh, value) => {
      if (value !== true || !(mesh.material instanceof THREE.MeshStandardMaterial)) return;
      mesh.material = patchMaterial(mesh.material, { snow: true });
      this.count++;
    });
  }

  update(state: WorldState): void {
    this.uniforms.uSnowCover.value = state.memory.snowCover;
  }

  get patchedCount(): number {
    return this.count;
  }
}
